import WebFont from 'webfontloader';

export default () => {
  WebFont.load({
    google: {
      families: [ 'Open+Sans: 100,300,400,400i,500,600,700' ]
    }
  });
}
